import { Component } from "@angular/core";

@Component({
  selector: 'app-transcript-error-dialog',
  templateUrl: './transcript-error-dialog.component.html',
  styleUrls: ['./transcript-error-dialog.component.scss']
})
export class TranscriptErrorDialogComponent {
}
